/**
 * Labstep
 *
 * @module grid/NewIndex/coldefs/experiment-workflow/folders
 * @desc Column Definition for experiment workflow folders
 */

import type {
  EditableCallbackParams,
  ValueGetterParams,
} from 'ag-grid-community';
import FolderManager from 'labstep-web/components/Folder/Manager';
import { ICONS } from 'labstep-web/constants/icons';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import type {
  CellEditorParams,
  CellRendererParams,
} from 'labstep-web/core/DataGrid/types';
import { stopEditingAndFocus } from 'labstep-web/core/DataGrid/utils';
import { GridNewIndexService } from 'labstep-web/grid/NewIndex/services/grid-new-index.service';
import type { Entity } from 'labstep-web/models/entity.model';
import type { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type { Folder } from 'labstep-web/models/folder.model';
import { Label } from 'semantic-ui-react';

export const colDefExperimentWorkflowFolders = {
  colId: 'folders',
  headerName: 'Collections',
  headerComponentParams: {
    icon: ICONS.folder.primary,
    postFilterSettings: {
      field: 'folders',
      disableSort: true,
    },
  },
  editable: (params: EditableCallbackParams) => {
    return GridNewIndexService.getEditable(params);
  },
  autoHeight: true,
  valueGetter: (params: ValueGetterParams): string | null =>
    params.data?.folders
      ?.map((folder: Folder) => folder.name)
      .join(',') || null,
  valueGetterExport: (params: ValueGetterParams) =>
    params.node?.data?.folders
      ?.map((folder: Folder) => folder.name)
      .join(',') || '',
  cellRenderer: (params: CellRendererParams<Entity>) => {
    return params.node?.data?.folder_preview?.map(
      (folder: Folder) => (
        <Label key={folder.id}>{folder.name}</Label>
      ),
    );
  },
  cellEditor: (params: CellEditorParams<ExperimentWorkflow>) => {
    const { data } = params;
    return (
      <ParamsStateContextProvider value={{}}>
        <FolderManager
          parentEntity={data}
          open
          onClose={(): void => stopEditingAndFocus(params)}
        />
      </ParamsStateContextProvider>
    );
  },
};
